import { useStore } from "stores/store";

export const useAuthAdmin = () => {
  const authAdmin = useStore((state) => state.authAdmin);
  return authAdmin;
};

export const useIsAuthAdminOrgAdmin = () => {
  const isOrgAdmin = useStore((state) => state.authAdmin?.org_admin) || false;
  return isOrgAdmin;
};

export const useIsAdmin = () => {
  const authAdmin = useAuthAdmin();
  return authAdmin !== undefined;
};

export const useAuthListUser = () => {
  const authListUser = useStore((state) => state.authListUser);
  return authListUser;
};

export const useIsListUser = () => {
  const authListUser = useAuthListUser();
  return authListUser !== undefined;
};
